// 사용정보 폼의 필수 필드 검증 (성상/일사용량/사용주기/일사용시간/월사용시간)
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field"]

  connect() {
    // Turbo 가 document-level capture phase 에서 submit 을 먼저 가로채는 케이스를 우회하기 위해
    // submit 버튼의 click 이벤트 (click → submit 순서) 에 capture phase 로 직접 바인딩.
    this._submitBtn = this.element.querySelector("button[type=submit]")
    if (this._submitBtn) {
      this._clickHandler = this.validate.bind(this)
      this._submitBtn.addEventListener("click", this._clickHandler, true)
    }
  }

  disconnect() {
    if (this._submitBtn && this._clickHandler) {
      this._submitBtn.removeEventListener("click", this._clickHandler, true)
    }
  }

  // submit 버튼 클릭 가로채기 — 미입력 있으면 차단 + 시각 강조 + 스크롤
  validate(event) {
    const formData = new FormData(this.element)
    let firstInvalid = null

    // 폼별 prefix 후보 — 사용정보(use_info / usage_info) + 전문가평가(expert_eval) + 개선기록(improvement_record).
    // unprefixed (literal name) 도 fallback 으로 시도 — 대응조치 modal 등 단일 필드 폼용.
    // 가장 먼저 non-empty 인 값을 채택.
    const prefixes = ["use_info", "usage_info", "expert_eval", "improvement_record"]

    this.fieldTargets.forEach((row) => {
      const names = row.dataset.fieldName.split(",").map((s) => s.trim()).filter(Boolean)
      const filled = names.every((name) => {
        let value = null
        for (const p of prefixes) {
          const v = formData.get(`${p}[${name}]`)
          if (v != null && v !== "") { value = v; break }
          if (value == null) value = v
        }
        // prefix 후보에 없으면 literal name 으로 시도
        if (value == null || value === "") value = formData.get(name)
        return value != null && String(value).trim() !== ""
      })

      this.toggleError(row, !filled)
      if (!filled && firstInvalid == null) firstInvalid = row
    })

    if (firstInvalid) {
      event.preventDefault()
      event.stopImmediatePropagation()
      event.stopPropagation()
      firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" })
    }
  }

  // 사용자가 라디오/입력 변경하면 해당 row 의 에러 표시 즉시 해제
  clear(event) {
    const row = event.target.closest("[data-usage-info-required-target='field']")
    if (row) this.toggleError(row, false)
  }

  toggleError(row, on) {
    row.classList.toggle("!border", on)
    row.classList.toggle("!border-[var(--danger-500)]", on)
    row.classList.toggle("!bg-[var(--danger-50)]", on)
    row.classList.toggle("!rounded-md", on)
    row.classList.toggle("!p-3", on)
  }
}
